import React, { useState, useEffect } from 'react'
import axios from 'axios'
import ThaiAddressFields, { addressOptions } from '../components/ThaiAddressFields'
// THAILAND_ADDRESS_V1

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api'
})

const STEPS = ['ข้อมูลส่วนตัว', 'ที่อยู่', 'ข้อมูลงาน', 'ยืนยัน']

const { POSITION_GROUPS } = require('../utils/positionCatalog')

export default function EmployeeRegistrationPage() {
  const [step, setStep] = useState(0)
  const [divisions, setDivisions] = useState([])
  const [saving, setSaving] = useState(false)
  const [done, setDone] = useState(false)
  const [refNo, setRefNo] = useState('')
  const [error, setError] = useState('')
  const [addressCatalog, setAddressCatalog] = useState([])
  const [addressLoadError, setAddressLoadError] = useState(false)
  const [manualAddress, setManualAddress] = useState(false)
  const [positionCustom, setPositionCustom] = useState('')
  const [idCardCheck, setIdCardCheck] = useState(null)
  const [idCardChecking, setIdCardChecking] = useState(false)
  const [emailCheck, setEmailCheck] = useState(null)
  const [emailChecking, setEmailChecking] = useState(false)
  const [form, setForm] = useState({
    prefix: 'นาย', first_name: '', last_name: '', id_card: '', birth_date: '',
    phone: '', email: '', house_no: '', village_no: '', road: '', subdistrict: '',
    district: '', province: '', zipcode: '', position: '', division_id: '',
    emp_type: 'ทั่วไป', note: ''
  })

  useEffect(() => {
    publicApi.get('/divisions/public').then(res => { if (res.data.success) setDivisions(res.data.data) }).catch(() => {})
    axios.get('/thailand-address-catalog.json?v=20261006').then(res => { if (!Array.isArray(res.data.rows)) throw Error('Invalid address catalog'); setAddressCatalog(res.data.rows) }).catch(() => setAddressLoadError(true))
  }, [])

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }))


  // เช็คเลขบัตรประชาชนซ้ำครับ
  const checkIdCard = async (idCard) => {
    if (idCard.length !== 13) {
      setIdCardCheck(null)
      return
    }
    try {
      setIdCardChecking(true)
      const res = await publicApi.get(`/registration/check-id/${idCard}`)
      if (res.data.exists) {
        setIdCardCheck({ duplicate: true, message: res.data.message })
      } else {
        setIdCardCheck({ duplicate: false })
      }
    } catch (err) {
      setIdCardCheck(null)
    } finally {
      setIdCardChecking(false)
    }
  }
// เช็ค Email ซ้ำครับ (debounce 600ms)
  const emailTimerRef = React.useRef(null)
  const checkEmail = (emailVal) => {
    setEmailCheck(null)
    if (emailTimerRef.current) clearTimeout(emailTimerRef.current)
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) return

    emailTimerRef.current = setTimeout(async () => {
      try {
        setEmailChecking(true)
        const res = await publicApi.get(`/registration/check-email/${encodeURIComponent(emailVal)}`)
        if (res.data.exists) {
          setEmailCheck({ duplicate: true, message: res.data.message })
        } else {
          setEmailCheck({ duplicate: false })
        }
      } catch (err) {
        setEmailCheck(null)
      } finally {
        setEmailChecking(false)
      }
    }, 600)
  }
  const calcAge = (birthDate) => {
    if (!birthDate) return null
    const today = new Date()
    const birth = new Date(birthDate)
    let age = today.getFullYear() - birth.getFullYear()
    const m = today.getMonth() - birth.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--
    return age
  }
  const age = calcAge(form.birth_date)

  const validateStep = () => {
    setError('')
    if (step === 0) {
      if (!form.first_name) { setError('กรุณากรอกชื่อ'); return false }
      if (!form.last_name) { setError('กรุณากรอกนามสกุล'); return false }
      if (!form.id_card || form.id_card.length !== 13) { setError('กรุณากรอกเลขบัตรประชาชน 13 หลัก'); return false }
      if (idCardCheck?.duplicate) { setError('เลขบัตรประชาชนนี้มีข้อมูลในระบบแล้ว ไม่สามารถลงทะเบียนซ้ำได้'); return false }
      if (!form.birth_date) { setError('กรุณากรอกวันเดือนปีเกิด'); return false }
      if (!form.phone || form.phone.length < 9) { setError('กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง'); return false }
      if (!form.email) { setError('กรุณากรอก Email'); return false }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) { setError('รูปแบบ Email ไม่ถูกต้อง'); return false }
      if (emailCheck?.duplicate) { setError('Email นี้มีข้อมูลในระบบแล้ว กรุณาใช้ Email อื่น'); return false }
    }
    if (step === 1) {
      if (!form.zipcode || form.zipcode.length !== 5) { setError('กรุณากรอกรหัสไปรษณีย์ 5 หลัก'); return false }
      if (!form.province) { setError('กรุณากรอกจังหวัด'); return false }
      if (!form.district) { setError('กรุณาเลือกหรือกรอกอำเภอ/เขต'); return false }
      if (!form.subdistrict) { setError('กรุณาเลือกตำบล/แขวง'); return false }
      if (!manualAddress && !addressOptions(addressCatalog, form).selected) {
        setError('กรุณาเลือกจังหวัด อำเภอ และตำบลให้สัมพันธ์กัน หรือเลือกกรอกที่อยู่เอง'); return false
      }
    }
    if (step === 2) {
      const finalPosition = form.position === 'อื่นๆ (ระบุเอง)' ? positionCustom : form.position
      if (!finalPosition) { setError('กรุณาเลือกหรือกรอกตำแหน่งงาน'); return false }
    }
    return true
  }

  const handleNext = () => { if (validateStep()) setStep(s => s + 1) }

  const handleSubmit = async () => {
    if (saving) return
    if (!form.pdpa_accepted || !form.pdpa_purpose_accepted) { setError('กรุณายินยอมให้เก็บข้อมูล PDPA'); return }
    setError('')
    setSaving(true)
    const finalPosition = form.position === 'อื่นๆ (ระบุเอง)' ? positionCustom : form.position
    try {
      const res = await publicApi.post('/registration', { ...form, position: finalPosition, id_card: form.id_card.replace(/\D/g, '') })
      if (res.data.success) { setRefNo(res.data.ref_no || ''); setDone(true) }
      else setError(res.data.message)
    } catch (err) { setError(err.response?.data?.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่') }
    finally { setSaving(false) }
  }

  const inputStyle = { width: '100%', padding: '10px 12px', border: '0.5px solid #e2e8f0', borderRadius: '10px', fontSize: '16px', color: '#0f172a', background: 'white', outline: 'none', fontFamily: 'inherit' }
  const labelStyle = { display: 'block', fontSize: '12px', color: '#374151', marginBottom: '5px' }
  const cardStyle = { background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px' }

  if (done) return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{ background: 'white', borderRadius: '20px', width: '100%', maxWidth: '380px', boxShadow: '0 8px 30px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <div style={{ background: 'linear-gradient(135deg, #16a34a, #22c55e)', padding: '32px', textAlign: 'center' }}>
          <div style={{ width: '64px', height: '64px', background: 'rgba(255,255,255,0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
            <i className="ti ti-circle-check" style={{ fontSize: '32px', color: 'white' }} />
          </div>
          <p style={{ fontSize: '18px', fontWeight: '500', color: 'white' }}>ลงทะเบียนสำเร็จ</p>
        </div>
        <div style={{ padding: '24px', textAlign: 'center' }}>
          {refNo && (
            <div style={{ background: '#eff6ff', borderRadius: '12px', padding: '14px', marginBottom: '16px' }}>
              <p style={{ fontSize: '11px', color: '#2563c5', marginBottom: '4px' }}>หมายเลขอ้างอิง</p>
              <p style={{ fontWeight: '500', color: '#0646a6', fontSize: '18px', letterSpacing: '0.05em' }}>{refNo}</p>
              <p style={{ fontSize: '11px', color: '#818cf8', marginTop: '4px' }}>กรุณาจดจำไว้ตรวจสอบสถานะครับ</p>
            </div>
          )}
          <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '4px' }}>ส่งข้อมูลเรียบร้อยแล้วครับ</p>
          <p style={{ fontSize: '13px', color: '#94a3b8', marginBottom: '14px' }}>กรุณารอเจ้าหน้าที่ HR ตรวจสอบและติดต่อกลับครับ</p>
          <p style={{ fontSize: '11px', color: '#cbd5e1' }}>หากมีข้อสงสัย ติดต่อ งานบุคคล โทร. 038-685-562 ต่อ 108</p>
        </div>
      </div>
    </div>
  )

  return (
    <div className="public-form-page register-redesign" style={{ minHeight: '100vh', background: '#f3f8ff' }}>
      {/* Header */}
      <div className="public-form-header" style={{ background: 'linear-gradient(110deg, #063b91, #075dcc, #1594df)', padding: '22px 16px', textAlign: 'center' }}>
        <p style={{ color: 'white', fontWeight: '500', fontSize: '16px' }}>แบบฟอร์มลงทะเบียนพนักงานจ้าง</p>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px', marginTop: '2px' }}>เทศบาลนครมาบตาพุด</p>
      </div>

      {/* Progress */}
      <div style={{ display: 'flex', background: 'white', borderBottom: '0.5px solid #e2e8f0' }}>
        {STEPS.map((s, i) => (
          <div key={i} style={{ flex: 1, padding: '11px 4px', textAlign: 'center', fontSize: '11px', fontWeight: '500', borderBottom: '2px solid', borderColor: step === i ? '#075dcc' : step > i ? '#22c55e' : 'transparent', color: step === i ? '#075dcc' : step > i ? '#22c55e' : '#cbd5e1' }}>
            {step > i ? '✓ ' : ''}{s}
          </div>
        ))}
      </div>

      <div style={{ maxWidth: '880px', margin: '0 auto', padding: '16px' }}>
        {error && (
          <div style={{ background: '#fef2f2', border: '0.5px solid #fecaca', color: '#ef4444', borderRadius: '12px', padding: '12px 16px', marginBottom: '14px', fontSize: '13px' }}>{error}</div>
        )}

        {/* Step 0 */}
        {step === 0 && (
          <div style={cardStyle}>
            <p style={{ fontSize: '15px', fontWeight: '500', color: '#0f172a' }}>ข้อมูลส่วนตัว</p>
            <div>
              <label style={labelStyle}>คำนำหน้า</label>
              <select value={form.prefix} onChange={e => set('prefix', e.target.value)} style={inputStyle}>
                <option>นาย</option><option>นาง</option><option>นางสาว</option>
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div><label style={labelStyle}>ชื่อ <span style={{ color: '#ef4444' }}>*</span></label><input type="text" value={form.first_name} onChange={e => set('first_name', e.target.value)} placeholder="ชื่อ" style={inputStyle} /></div>
              <div><label style={labelStyle}>นามสกุล <span style={{ color: '#ef4444' }}>*</span></label><input type="text" value={form.last_name} onChange={e => set('last_name', e.target.value)} placeholder="นามสกุล" style={inputStyle} /></div>
            </div>

            <div>
              <label style={labelStyle}>เลขบัตรประชาชน <span style={{ color: '#ef4444' }}>*</span></label>
              <input type="text" value={form.id_card}
                onChange={e => {
                  const val = e.target.value.replace(/\D/g, '').slice(0, 13)
                  set('id_card', val)
                  checkIdCard(val)
                }}
                placeholder="เลข 13 หลัก" maxLength={13}
                style={{ ...inputStyle, letterSpacing: '0.1em', borderColor: idCardCheck?.duplicate ? '#ef4444' : idCardCheck?.duplicate === false ? '#22c55e' : '#e2e8f0' }} />
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '4px' }}>
                <p style={{ fontSize: '11px', color: '#cbd5e1' }}>{form.id_card.length}/13</p>
                {idCardChecking && <p style={{ fontSize: '11px', color: '#94a3b8' }}>กำลังตรวจสอบ...</p>}
              </div>
              {idCardCheck?.duplicate && (
                <div style={{ marginTop: '6px', background: '#fef2f2', border: '0.5px solid #fecaca', borderRadius: '8px', padding: '10px 12px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                  <i className="ti ti-alert-circle" style={{ fontSize: '16px', color: '#ef4444', flexShrink: 0, marginTop: '1px' }} />
                  <p style={{ fontSize: '12px', color: '#991b1b' }}>{idCardCheck.message}</p>
                </div>
              )}
              {idCardCheck?.duplicate === false && (
                <p style={{ fontSize: '12px', color: '#22c55e', marginTop: '6px' }}>✅ เลขบัตรประชาชนนี้ยังไม่มีในระบบครับ</p>
              )}
            </div>

            <div>
              <label style={labelStyle}>วันเดือนปีเกิด <span style={{ color: '#ef4444' }}>*</span></label>
              <input type="date" value={form.birth_date} onChange={e => set('birth_date', e.target.value)} style={inputStyle} />
              {age !== null && <p style={{ fontSize: '12px', color: '#075dcc', marginTop: '4px', fontWeight: '500' }}>อายุ {age} ปี</p>}
            </div>
            <div>
              <label style={labelStyle}>เบอร์โทรศัพท์ <span style={{ color: '#ef4444' }}>*</span></label>
              <input type="tel" value={form.phone} onChange={e => set('phone', e.target.value.replace(/\D/g, '').slice(0, 10))} placeholder="0XXXXXXXXX" maxLength={10} style={{ ...inputStyle, letterSpacing: '0.1em' }} />
              <p style={{ fontSize: '11px', color: '#cbd5e1', marginTop: '4px' }}>{form.phone.length}/10</p>
            </div>
            <div>
              <label style={labelStyle}>Email <span style={{ color: '#ef4444' }}>*</span></label>
              <input type="email" value={form.email}
                onChange={e => {
                  const val = e.target.value
                  set('email', val)
                  checkEmail(val)
                }}
                placeholder="example@email.com"
                style={{ ...inputStyle, borderColor: emailCheck?.duplicate ? '#ef4444' : emailCheck?.duplicate === false ? '#22c55e' : '#e2e8f0' }} />
              {emailChecking && <p style={{ fontSize: '11px', color: '#94a3b8', marginTop: '4px' }}>กำลังตรวจสอบ...</p>}
              {emailCheck?.duplicate && (
                <div style={{ marginTop: '6px', background: '#fef2f2', border: '0.5px solid #fecaca', borderRadius: '8px', padding: '10px 12px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                  <i className="ti ti-alert-circle" style={{ fontSize: '16px', color: '#ef4444', flexShrink: 0, marginTop: '1px' }} />
                  <p style={{ fontSize: '12px', color: '#991b1b' }}>{emailCheck.message}</p>
                </div>
              )}
              {emailCheck?.duplicate === false && (
                <p style={{ fontSize: '12px', color: '#22c55e', marginTop: '6px' }}>✅ Email นี้ยังไม่มีในระบบครับ</p>
              )}
            </div>
          </div>
        )}

        {/* Step 1 */}
        {step === 1 && (
          <div style={cardStyle}>
            <p style={{ fontSize: '15px', fontWeight: '500', color: '#0f172a' }}>ที่อยู่ตามบัตรประชาชน</p>
            <ThaiAddressFields rows={addressCatalog} form={form} setForm={setForm} manual={manualAddress} setManual={setManualAddress} loadError={addressLoadError} inputStyle={inputStyle} labelStyle={labelStyle} />
          </div>
        )}

        {/* Step 2 */}
        {step === 2 && (
          <div style={cardStyle}>
            <p style={{ fontSize: '15px', fontWeight: '500', color: '#0f172a' }}>ข้อมูลการทำงาน</p>
            <div>
              <label style={labelStyle}>ประเภทพนักงาน</label>
              <select value={form.emp_type} onChange={e => { setForm(f => ({ ...f, emp_type: e.target.value, position: '' })); setPositionCustom('') }} style={inputStyle}>
                <option value="ทั่วไป">ทั่วไป</option>
                <option value="ตามภารกิจ">ตามภารกิจ</option>
                <option value="ผู้เชี่ยวชาญพิเศษ">ผู้เชี่ยวชาญพิเศษ</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>ตำแหน่งงาน <span style={{ color: '#ef4444' }}>*</span></label>
              <select value={form.position} onChange={e => set('position', e.target.value)} style={inputStyle}>
                <option value="">เลือกตำแหน่งงาน</option>
                {POSITION_GROUPS.filter(g => g.empType === form.emp_type).map(g => <optgroup key={g.label} label={g.label}>{g.positions.map(p => <option key={p} value={p}>{p}</option>)}</optgroup>)}
                {form.emp_type === 'ผู้เชี่ยวชาญพิเศษ' && <option value="อื่นๆ (ระบุเอง)">อื่นๆ (ระบุเอง)</option>}
              </select>
              {form.position === 'อื่นๆ (ระบุเอง)' && (
                <input type="text" value={positionCustom} onChange={e => setPositionCustom(e.target.value)} placeholder="กรอกตำแหน่งงาน" style={{ ...inputStyle, marginTop: '8px' }} />
              )}
            </div>
            <div>
              <label style={labelStyle}>สังกัด/กอง <span style={{ color: '#ef4444' }}>*</span></label>
              {divisions.length > 0 ? (
                <select value={form.division_id} onChange={e => set('division_id', e.target.value)} style={inputStyle}>
                  <option value="">เลือกกองงาน</option>
                  {divisions.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                </select>
              ) : (
                <div style={{ ...inputStyle, background: '#f8fafc', color: '#94a3b8' }}>กำลังโหลด...</div>
              )}
            </div>
            <div>
              <label style={labelStyle}>หมายเหตุ</label>
              <textarea value={form.note} onChange={e => set('note', e.target.value)} rows={3} placeholder="ข้อมูลเพิ่มเติม (ถ้ามี)" style={{ ...inputStyle, resize: 'none' }} />
            </div>
          </div>
        )}

        {/* Step 3 */}
        {step === 3 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div style={cardStyle}>
              <p style={{ fontSize: '15px', fontWeight: '500', color: '#0f172a' }}>ตรวจสอบข้อมูลก่อนส่ง</p>
              {[
                { title: 'ข้อมูลส่วนตัว', rows: [
                  ['ชื่อ-นามสกุล', `${form.prefix}${form.first_name} ${form.last_name}`],
                  ['เลขบัตร', form.id_card],
                  ['วันเกิด', form.birth_date ? new Date(form.birth_date).toLocaleDateString('th-TH') : '-'],
                  ['อายุ', age !== null ? `${age} ปี` : '-'],
                  ['โทรศัพท์', form.phone],
                  ['Email', form.email],
                ]},
                { title: 'ข้อมูลการทำงาน', rows: [
                  ['ตำแหน่ง', form.position === 'อื่นๆ (ระบุเอง)' ? positionCustom : form.position || '-'],
                  ['กองงาน', divisions.find(d => d.id === form.division_id)?.name || '-'],
                  ['ประเภท', form.emp_type],
                ]},
              ].map((section, si) => (
                <div key={si} style={{ background: '#f8fafc', borderRadius: '10px', padding: '14px' }}>
                  <p style={{ fontSize: '10px', fontWeight: '500', color: '#94a3b8', textTransform: 'uppercase', marginBottom: '10px' }}>{section.title}</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {section.rows.map(([label, value]) => (
                      <div key={label} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontSize: '12px', color: '#94a3b8' }}>{label}</span>
                        <span style={{ fontSize: '13px', fontWeight: '500', color: '#0f172a' }}>{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '14px' }}>
                <p style={{ fontSize: '10px', fontWeight: '500', color: '#94a3b8', textTransform: 'uppercase', marginBottom: '8px' }}>ที่อยู่</p>
                <p style={{ fontSize: '13px', fontWeight: '500', color: '#0f172a', lineHeight: '1.6' }}>
                  {[form.house_no, form.village_no ? `หมู่ ${form.village_no}` : '', form.road ? `ถนน${form.road}` : '', form.subdistrict ? `ต.${form.subdistrict}` : '', form.district ? `อ.${form.district}` : '', form.province ? `จ.${form.province}` : '', form.zipcode].filter(Boolean).join(' ') || '-'}
                </p>
              </div>
            </div>

            <section className="consent-panel" aria-labelledby="privacy-title">
              <h2 id="privacy-title"><i className="ti ti-shield-check" aria-hidden="true" /> นโยบายคุ้มครองข้อมูลส่วนบุคคล</h2>
              <p>ข้าพเจ้ายินยอมให้เทศบาลนครมาบตาพุดเก็บรวบรวมข้อมูลส่วนบุคคลข้างต้น เพื่อใช้ในการจัดทำสัญญาจ้างพนักงาน ตาม พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562</p>
              <div className="retention-note"><strong>ระยะเวลาการจัดเก็บข้อมูล</strong><p>จัดเก็บต่อเนื่องตลอดอายุการจ้างงาน</p></div>
              <div className="electronic-contract-note">
                <strong>ข้อกำหนดสัญญาอิเล็กทรอนิกส์</strong>
                <p>สัญญาฉบับนี้จัดทำด้วยระบบอิเล็กทรอนิกส์ คู่สัญญาได้อ่านและพิจารณาข้อความโดยละเอียดแล้วจึงลงลายมือชื่ออิเล็กทรอนิกส์ และต่างเก็บรักษาสัญญาในรูปแบบของข้อมูลอิเล็กทรอนิกส์ไว้ในระบบคอมพิวเตอร์ของตน</p>
              </div>
              <label className="consent-choice"><input id="pdpa-existing" type="checkbox" checked={form.pdpa_accepted === true} onChange={e => setForm({...form,pdpa_accepted:e.target.checked})} /><span>ข้าพเจ้ายินยอมให้เก็บข้อมูล (PDPA)</span></label>
              <label className="consent-choice"><input id="pdpa-purpose" type="checkbox" checked={form.pdpa_purpose_accepted === true} onChange={e => setForm({...form,pdpa_purpose_accepted:e.target.checked})} /><span>ข้าพเจ้ายินยอมให้เทศบาลนครมาบตาพุดเก็บรวบรวม ใช้ ข้อมูลตามวัตถุประสงค์</span></label>
              <small>กรุณาอ่านและเลือกช่องยืนยันทั้งสองช่องก่อนส่งข้อมูล</small>
            </section>
          </div>
        )}

        {/* Navigation */}
        <div style={{ display: 'flex', gap: '10px', marginTop: '14px' }}>
          {step > 0 && (
            <button onClick={() => setStep(s => s - 1)} style={{ flex: 1, padding: '12px', background: 'white', color: '#64748b', border: '0.5px solid #e2e8f0', borderRadius: '12px', fontSize: '13px', cursor: 'pointer' }}>ย้อนกลับ</button>
          )}
          {step < STEPS.length - 1 ? (
            <button className="ice-primary-action" onClick={handleNext} style={{ flex: 1, padding: '12px', background: '#075dcc', color: 'white', border: 'none', borderRadius: '12px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }}>ถัดไป</button>
          ) : (
            <button className="ice-primary-action" onClick={handleSubmit} disabled={saving || !form.pdpa_accepted || !form.pdpa_purpose_accepted} style={{ flex: 1, padding: '12px', background: saving ? '#86efac' : '#22c55e', color: 'white', border: 'none', borderRadius: '12px', fontSize: '13px', fontWeight: '500', cursor: saving ? 'not-allowed' : 'pointer' }}>
              {saving ? 'กำลังส่งข้อมูล...' : 'ยืนยันส่งข้อมูล'}
            </button>
          )}
        </div>

        <p style={{ textAlign: 'center', fontSize: '11px', color: '#cbd5e1', marginTop: '16px' }}>สอบถาม งานบุคคล โทร. 038-621-139</p>
      </div>
    </div>
  )
}
